import './style.scss'

import React, { Component } from 'react'

import AppPortal from 'components/UI/AppPortal'
import Icon from 'components/UI/Icon'
import PropTypes from 'prop-types'
import cartIcon from 'theme/icons/cart.svg'
import { connect } from 'react-redux'
import find from 'lodash/find'
import { withTranslation } from 'react-i18next'

const duration = 2500

export class CartNotification extends Component {
    componentWillReceiveProps(props) {
        clearTimeout(this.timer)

        if (props.action) {
            this.timer = setTimeout(
                () => this.props.dispatch({ type: 'RESET_CART_NOTIFICATION' }),
                duration
            )
        }
    }

    message() {
        const { action, product, products, t } = this.props
        const cartProduct = find(products, (p) => p.id === product.id)
        const quantity = cartProduct ? cartProduct.quantity : 0

        if (action === 'add') {
            return t('cartCartNotificationAdded', {
                quantity,
                productTitle: product.title,
            })
        } else if (quantity === 0) {
            return t('cartCartNotificationDeleted', { productTitle: product.title })
        } else {
            return t('cartCartNotification', {
                quantity,
                productTitle: product.title,
            })
        }
    }

    render() {
        const { product, showCart, isMobile } = this.props

        if (showCart || !product || isMobile) return null

        return (
            <AppPortal>
                <div className="cart-notification">
                    <Icon svg={cartIcon} />
                    <span>{this.message()}</span>
                </div>
            </AppPortal>
        )
    }
}

CartNotification.propTypes = {
    action: PropTypes.string,
    product: PropTypes.object,
    products: PropTypes.array,
    showCart: PropTypes.bool,
    isMobile: PropTypes.bool,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

export const mapStateToProps = ({ cartNotification, cart, ui }) => ({
    action: cartNotification.action,
    product: cartNotification.product,
    products: cart.products,
    showCart: ui.showCart,
    isMobile: ui.isMobile,
})

export default connect(mapStateToProps)(withTranslation()(CartNotification))
